const mdSize = {height: 11, borderRadius: 'base'}

export default {
    sizes: {
        md: {
            field: {...mdSize, px: 3},
            addon: mdSize
        }
    },
    baseStyle: {
        field: {
            _focus: {
                borderColor: 'blue.600'
            }
        }
    },
    variants: {
        outline: {
            field: {
                borderColor: 'gray.500'
            }
        },
        filled: {
            // we use filled variant for
            // search input
            field: {
                borderColor: 'gray.600',
                backgroundColor: 'gray.100',
                _focus: {
                    backgroundColor: 'white'
                },
                _hover: {
                    backgroundColor: 'gray.100',
                    _focus: {
                        backgroundColor: 'white'
                    }
                },
                _placeholder: {
                    color: 'gray.700'
                }
            }
        },
        inner: {
            field: {
                zIndex: '1',
                height: '40px',
                lineHeight: '20px',
                maxWidth: '100%',
                border: '1px solid',
                borderColor: 'gray.325',
                boxSizing: 'border-box',
                padding: '9px 15px 9px 50px',
                textIndent: 0,
                borderRadius: 0,

                _focus: {
                    backgroundColor: 'white',
                    borderstyle: 'solid',
                    borderColor: 'black',
                    borderRadius: '4px',
                    borderWidth: '2px'
                },
                _invalid: {
                    backgroundColor: 'red.750',
                    border: '1px solid',
                    borderColor: 'red.550',
                    borderRadius: 0,
                    _focus: {
                        borderstyle: 'solid',
                        borderColor: 'black',
                        borderRadius: '4px',
                        borderWidth: '2px'
                    }
                },
                _placeholder: {
                    color: 'gray.650'
                }
            }
        },
        address: {
            field: {
                height: '40px',
                lineHeight: '20px',
                maxWidth: '100%',
                border: '1px solid',
                borderColor: 'gray.325',
                boxSizing: 'border-box',
                padding: '9px 15px',
                textIndent: 0,
                borderRadius: 0,

                _focus: {
                    backgroundColor: 'white',
                    borderstyle: 'solid',
                    borderColor: 'black',
                    borderRadius: '4px',
                    borderWidth: '2px'
                },
                _invalid: {
                    backgroundColor: 'red.750',
                    border: '1px solid',
                    borderColor: 'red.550',
                    borderRadius: 0,
                    _focus: {
                        borderstyle: 'solid',
                        borderColor: 'black',
                        borderRadius: '4px',
                        borderWidth: '2px'
                    }
                },
                _placeholder: {
                    color: 'gray.650'
                }
            }
        },
        formlabelSelect: {
            width: {base: '100%', md: '47%'},
            marginBottom: '0',
            fontSize: '13px',
            fontWeight: '700'
        }
    }
}
